// extracted by mini-css-extract-plugin
export default {"statIndicator":"StatIndicator_statIndicator__DTfFh","statValueContainer":"StatIndicator_statValueContainer__-1lqZ","modifier":"StatIndicator_modifier__wUfks"};